/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const userMembershipPageResponseOutputItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const userMembershipPageResponseOutputItemsItemTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const userMembershipPageResponseOutputItemsItemUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const userMembershipPageResponseOutputItemsItemDisplayNameMax = 200;

export const userMembershipPageResponseOutputItemsItemStartedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const userMembershipPageResponseOutputItemsItemEndedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const userMembershipPageResponseOutputItemsItemVersionExclusiveMin = 0;
export const userMembershipPageResponseOutputItemsItemVersionMax = 9007199254740991;

export const userMembershipPageResponseOutputNextCursorOneMax = 512;

export const userMembershipPageResponseOutputNextCursorOneRegExp = new RegExp('^[A-Za-z0-9_-]+$');

export const UserMembershipPageResponseOutput = zod.object({
  items: zod.array(
    zod.object({
      id: zod.uuid().regex(userMembershipPageResponseOutputItemsItemIdRegExp),
      teamId: zod.uuid().regex(userMembershipPageResponseOutputItemsItemTeamIdRegExp),
      userId: zod.uuid().regex(userMembershipPageResponseOutputItemsItemUserIdRegExp),
      displayName: zod.string().min(1).max(userMembershipPageResponseOutputItemsItemDisplayNameMax),
      startedAt: zod.iso
        .datetime({ offset: true })
        .regex(userMembershipPageResponseOutputItemsItemStartedAtRegExp),
      endedAt: zod.union([
        zod.iso
          .datetime({ offset: true })
          .regex(userMembershipPageResponseOutputItemsItemEndedAtOneRegExp),
        zod.null(),
      ]),
      version: zod
        .int()
        .gt(userMembershipPageResponseOutputItemsItemVersionExclusiveMin)
        .max(userMembershipPageResponseOutputItemsItemVersionMax),
      teamActive: zod.boolean(),
      effective: zod.boolean(),
    }),
  ),
  nextCursor: zod.union([
    zod
      .string()
      .min(1)
      .max(userMembershipPageResponseOutputNextCursorOneMax)
      .regex(userMembershipPageResponseOutputNextCursorOneRegExp),
    zod.null(),
  ]),
});

export type UserMembershipPageResponseOutput = zod.input<typeof UserMembershipPageResponseOutput>;
export type UserMembershipPageResponseOutputOutput = zod.output<
  typeof UserMembershipPageResponseOutput
>;
